export const USER_LOGIN = 'USER_LOGIN';
export const USER_LOGIN_SUCCESS = 'USER_LOGIN_SUCCESS';
export const USER_LOGIN_ERROR = 'USER_LOGIN_ERROR';

export const GET_AUTH_USER = 'GET_AUTH_USER';
export const GET_AUTH_USER_SUCCESS = 'GET_AUTH_USER_SUCCESS';
export const GET_AUTH_USER_ERROR = 'GET_AUTH_USER_ERROR';

export const USER_LOGOUT = 'USER_LOGOUT';
